import React, {FC, memo, useCallback, useState} from 'react';

// Import Styles
import styled from 'styled-components';

// React Share
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  WhatsappShareButton,
  WhatsappIcon,
  ViberShareButton,
  ViberIcon,
}
  from "react-share";

import { truncateMetaDescription } from '../../../utils/helpers';
import colors from '../../../config/colors';

interface ISocialShare {
    title: string
    description?: string
}

const SocialShare: FC<ISocialShare> = ({title, description}) => {

  const [copySuccess, setCopySuccess] = useState('');

  const copy = useCallback(() => {
    navigator.clipboard.writeText(window.location.href);
    setCopySuccess('Kopirano!');
    setTimeout(() => setCopySuccess(''), 3000);
  }, []);

  return (

      <ShareButtons>
        <FacebookShareButton
            url={window.location.href}
            quote={title}
        >
            <FacebookIcon size={36} />
        </FacebookShareButton>

        <TwitterShareButton
            url={window.location.href}
            title={title}
        >
            <TwitterIcon size={36} />
        </TwitterShareButton>

        <TelegramShareButton
            url={window.location.href}
            title={title}
        >
            <TelegramIcon size={36} />
        </TelegramShareButton>

        <WhatsappShareButton
            url={window.location.href}
            title={title}
        >
            <WhatsappIcon size={36} />
        </WhatsappShareButton>

        <LinkedinShareButton
            url={window.location.href}
            title={title}
            summary={description ? truncateMetaDescription(description) : ''}
        >
            <LinkedinIcon size={36} />
        </LinkedinShareButton>

        <ViberShareButton
            url={window.location.href}
            title={title.substring(0, 100) + '...'}
        >
            <ViberIcon size={36} />
        </ViberShareButton>

        <CopyLinkShareButton onClick={copy}>
          <svg><use xlinkHref={`#copy`} /></svg>
          <span className={copySuccess ? 'show' : ''}>{copySuccess}</span>
        </CopyLinkShareButton>
    </ShareButtons>

  )
}

const ShareButtons = styled.div`
  background: ${colors.WHITE};
  padding: 6px;
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px rgb(0 0 0 / 7%);

  @media (max-width: 576px) {
    max-width: 100%;
    margin: 0 auto;
    padding: 4px;
    flex-wrap: wrap;
  }

  button {
    width: 30px;
    height: 30px;
    margin: 6px !important;
    border-radius: 5px;
    overflow: hidden;

    @media (max-width: 576px) {
      width: 30px !important;
      margin: 4px !important;
    }

    svg {
      width: 30px;
      height: 30px;
      vertical-align: middle;
      transition: all 100ms ease-in-out;
    }

    &:hover {

      svg {
        opacity: 0.7;
      }
    }
  }
`;

const CopyLinkShareButton = styled.button`
  margin-right: 10px;
  width: 30px;
  height: 30px;
  transition: opacity 100ms ease-in-out;
  background: ${colors.GRAY_BUTTON};
  position: relative;
  overflow: visible !important;

  svg {
    fill: ${colors.WHITE_COLOR};
    vertical-align: middle;
    width: 20px !important;
    height: 20px !important;
  }

  span {
    position: absolute;
    top: -35px;
    left: 0;
    padding: 4px 14px;
    background: ${colors.GRAY_BUTTON};
    border-radius: 5px;
    color: ${colors.WHITE_COLOR};
    font-family: "Gilroy-Medium";
    font-weight: 500;
    pointer-events: none;
    opacity: 0;

    &.show {
      opacity: 1;
    }
  }
`;

export default memo(SocialShare);
